<template>
    <landing-page
    label="tpa.tpa"
    description="tpa.tpaDesc"
    labelColor="#82488F"
    descColor="#82488F"
    :eggImgObj="{ componentName: 'tpa', imgName: 'tpa', imgFormat: 'svg' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconPurpleRight', imgFormat: 'svg' }"
    class="mb-10"
  />
</template>

<script setup lang="ts">
import { useTpaStore } from "@/stores/tpa";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const tpaStore = useTpaStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>